import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header as AuthHeader, Footer as AuthFooter, Sidebar } from "../layout/AllLayouts";
import { Layout, Modal, Steps, Col, Row, Button, Space, Divider, Typography, Switch } from "antd";
import ReactPlayer from "react-player/youtube";
const { Header, Content, Sider, Footer } = Layout;

function AuthLayout(props) {
  let location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [welcomeTourOpen, setWelcomeTourOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const [showWelcomePackage, setShowWelcomePackage] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);

  const UpdateWelcomePackagePreference = async (value) => {
    await props.AxiosRequest("/api/welcome-package-preference/update", { show: value ? 1 : 0 });
  };

  const steps = [
    {
      title: (
        <Space split={<Divider type="vertical" />} className="w-100">
          <div>Welcome to FirmTamer</div>
          <div className="text-right">(1:35)</div>
        </Space>
      ),
      content: (
        <Row gutter={[16, 16]}>
          <Col span={24} className="text-center">
            <Typography.Title level={5}>Get Started With FirmTamer</Typography.Title>
          </Col>
          <Col span={24} className="text-center">
            FirmTamer is a practice management software that can help firms stay organized, capture more billable time, and make strategic data-driven decisions. This video playlist aims to be concise
            and help you get started using FirmTamer! <b>For best results, we recommend using 2 monitors and following along with the videos.</b>
          </Col>
          <Col span={24} className="text-center">
            <ReactPlayer url="https://www.youtube.com/watch?v=Mt2TcePH_KE" width="100%" className="text-center" controls={true} playing={videoPlaying} />
          </Col>
        </Row>
      ),
    },
    {
      title: (
        <Space split={<Divider type="vertical" />} className="w-100">
          <div>Add Your First Client</div>
          <div className="text-right">(1:43)</div>
        </Space>
      ),
      content: (
        <Row gutter={[16, 16]}>
          <Col span={24} className="text-center">
            <Typography.Title level={5}>Adding A Client In FirmTamer</Typography.Title>
          </Col>
          <Col span={24} className="text-center">
            <ReactPlayer url="https://www.youtube.com/watch?v=zLURpErkqqk" width="100%" className="text-center" controls={true} playing={videoPlaying} />
          </Col>
        </Row>
      ),
    },
    {
      title: (
        <Space split={<Divider type="vertical" />} className="w-100">
          <div>Add Your First Job and Task</div>
          <div className="text-right">(2:44)</div>
        </Space>
      ),
      content: (
        <Row gutter={[16, 16]}>
          <Col span={24} className="text-center">
            <Typography.Title level={5}>Addding a Job and Task to your Client</Typography.Title>
          </Col>
          <Col span={24} className="text-center">
            <ReactPlayer url="https://www.youtube.com/watch?v=oeSGjBMZ6NE" width="100%" className="text-center" controls={true} playing={videoPlaying} />
          </Col>
        </Row>
      ),
    },
    {
      title: (
        <Space split={<Divider type="vertical" />} className="w-100">
          <div>Entering Your Time</div>
          <div className="text-right">(1:43)</div>
        </Space>
      ),
      content: (
        <Row gutter={[16, 16]}>
          <Col span={24} className="text-center">
            <Typography.Title level={5}>Entering Your Time</Typography.Title>
          </Col>
          <Col span={24} className="text-center">
            <ReactPlayer url="https://www.youtube.com/watch?v=v27m9b_odp0" width="100%" className="text-center" controls={true} playing={videoPlaying} />
          </Col>
        </Row>
      ),
    },
    {
      title: (
        <Space split={<Divider type="vertical" />} className="w-100">
          <div>Using the Taskboard</div>
          <div className="text-right">(1:21)</div>
        </Space>
      ),
      content: (
        <Row gutter={[16, 16]}>
          <Col span={24} className="text-center">
            <Typography.Title level={5}>Using Your Taskboard</Typography.Title>
          </Col>
          <Col span={24} className="text-center">
            <ReactPlayer url="https://www.youtube.com/watch?v=BaLEIwZe3Ek" width="100%" className="text-center" controls={true} playing={videoPlaying} />
          </Col>
        </Row>
      ),
    },
    {
      title: (
        <Space split={<Divider type="vertical" />} className="w-100">
          <div>Creating an Invoice</div>
          <div className="text-right">(3:10)</div>
        </Space>
      ),
      content: (
        <Row gutter={[16, 16]}>
          <Col span={24} className="text-center">
            <Typography.Title level={5}>Creating Invoices in FirmTamer</Typography.Title>
          </Col>
          <Col span={24} className="text-center">
            <ReactPlayer url="https://www.youtube.com/watch?v=L5RsjM5RSOY" width="100%" className="text-center" controls={true} playing={videoPlaying} />
          </Col>
        </Row>
      ),
    },
    {
      title: (
        <Space split={<Divider type="vertical" />} className="w-100">
          <div>Running Useful Reports</div>
          <div className="text-right">(3:37)</div>
        </Space>
      ),
      content: (
        <Row gutter={[16, 16]}>
          <Col span={24} className="text-center">
            <Typography.Title level={5}>Getting Data-Driven In FirmTamer</Typography.Title>
          </Col>
          <Col span={24} className="text-center">
            <ReactPlayer url="https://www.youtube.com/watch?v=1KZMW1wmiQQ" width="100%" className="text-center" controls={true} playing={videoPlaying} />
          </Col>
        </Row>
      ),
    },
  ];

  useEffect(() => {
    setVideoPlaying(false);
  }, [currentStep]);

  useEffect(() => {
    if (props?.userPreferences?.welcome_package_show !== null) {
      setShowWelcomePackage(props?.userPreferences?.welcome_package_show ? true : false); //ternary turns 1/0 into true/false
    }
    if (props?.userPreferences?.welcome_package_show && location.pathname === "/clients") {
      setWelcomeTourOpen(true);
    }
    // eslint-disable-next-line
  }, [props?.userPreferences]);

  return (
    <div className="wrapper">
      <Layout style={{ minHeight: "100vh" }}>
        <Sider width={250} collapsible collapsed={collapsed} style={{ paddingBottom: "0px" }} trigger={null}>
          <Sidebar {...props} collapsed={collapsed} setWelcomeTourOpen={setWelcomeTourOpen} />
        </Sider>
        <Layout>
          <Header style={{ paddingLeft: "10px", paddingRight: "10px" }}>
            <AuthHeader collapsed={collapsed} setCollapsed={setCollapsed} {...props} setAuthToken={props.setAuthToken} setWelcomeTourOpen={setWelcomeTourOpen} />
          </Header>
          <Content>
            <Outlet />
          </Content>
          <Footer>
            <AuthFooter {...props} />
          </Footer>
        </Layout>
        <Modal
          destroyOnClose
          width={1000}
          mask={true}
          open={welcomeTourOpen}
          placement="center"
          steps={steps}
          onCancel={() => {
            setWelcomeTourOpen(false);
            setVideoPlaying(false);
          }}
          footer={
            <Row gutter={[16, 16]}>
              <Col span={12} className="text-left">
                <label className="col-form-label-sm w-100">Show this when you log in?</label>
                <Switch
                  onChange={(value) => {
                    UpdateWelcomePackagePreference(value);
                    setShowWelcomePackage(!showWelcomePackage);
                  }}
                  checked={showWelcomePackage}
                />
              </Col>
              <Col span={12} className="text-right">
                <Space>
                  {currentStep !== 0 ? (
                    <Button
                      onClick={() => {
                        setCurrentStep(currentStep - 1);
                      }}
                    >
                      Previous
                    </Button>
                  ) : null}
                  {currentStep !== steps.length - 1 ? (
                    <Button
                      onClick={() => {
                        setCurrentStep(currentStep + 1);
                      }}
                      type="primary"
                    >
                      Next
                    </Button>
                  ) : null}
                </Space>
              </Col>
            </Row>
          }
        >
          <Row gutter={[16, 16]}>
            <Col span={24} className="text-center">
              {/* <Typography.Title level={3}>FirmTamer Tutorial</Typography.Title> */}
            </Col>
            <Col span={6} className="text-left mt-5">
              <Steps className="text-left" direction="vertical" size="small" type="default" items={steps} current={currentStep} onChange={(e) => setCurrentStep(e)} />
            </Col>
            <Col span={18} style={{ margin: "auto" }}>
              {steps[currentStep].content}
            </Col>
          </Row>
        </Modal>
      </Layout>
    </div>
  );
}

export default AuthLayout;
